import NavigationNode from '@/services/NavigationNode';

export default interface Navigation {
	id: number | null;
	name: string | null;
	tier1: Tier;
	tier2: Tier;
	tier3: Tier;
	nodes: Array<NavigationNode>;
}

export interface Tier {
	display: boolean;
	type: string;
}

export function navFactory(): Navigation {
	return {
		id: null,
		name: '',
		tier1: {
			type: 'all',
			display: true
		},
		tier2: {
			type: 'all',
			display: true
		},
		tier3: {
			type: 'all',
			display: true
		},
		nodes: []
	};
}